var React = require('react');

function PaymentsOrchestration (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#DDE0FF","key":0}),React.createElement("path",{"d":"M10 19.5C10 19.225 10.225 19 10.5 19H12.5C12.775 19 13 19.225 13 19.5C13 19.775 12.775 20 12.5 20H10.5C10.225 20 10 19.775 10 19.5ZM14 19.5C14 19.225 14.225 19 14.5 19H18.5C18.775 19 19 19.225 19 19.5C19 19.775 18.775 20 18.5 20H14.5C14.225 20 14 19.775 14 19.5ZM7 11C7 9.89531 7.89531 9 9 9H23C24.1031 9 25 9.89531 25 11V21C25 22.1031 24.1031 23 23 23H9C7.89531 23 7 22.1031 7 21V11ZM8 11V12H24V11C24 10.4478 23.5531 10 23 10H9C8.44781 10 8 10.4478 8 11ZM8 15V21C8 21.5531 8.44781 22 9 22H23C23.5531 22 24 21.5531 24 21V15H8Z","fill":"#212121","key":1})]);
}

PaymentsOrchestration.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = PaymentsOrchestration;

PaymentsOrchestration.default = PaymentsOrchestration;
